<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">HKT Orders</h3>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="4" class="pr-1">
            <b-form-file
              v-model="upload_file"
              placeholder="Choose a file..."
            ></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onUploadFile"
              >Upload</b-button
            >
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col class="text-left">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="bulkDownloadWayBill()"
              >Bulk Download Waybill</b-button
            >
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <!-- <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.status_selected"
              :options="status_options"
            />
          </b-col> -->
          <b-col cols="4" class="pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Order# / Tracking # / Ship From ID"
              v-model="search_criteria.keyword"
             @keyup.enter="onSearch"></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search" />Search
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        :items="items"
        :fields="fields"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>

        <template v-slot:cell(ship_from_id)="data">
          <span v-if="!data.item.ship_from_id || data.item.ship_from_id == ''">Clublike</span>
          <span v-if="data.item.ship_from_id != ''">{{data.item.ship_from_id}}</span>
        </template>

        <template v-slot:cell(waybill_download)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            @click="downloadWaybill(data.item)"
            >Download</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "chk_box",
    label: ""
  },
  {
    key: "created_at_ts",
    label: "Uploaded at"
  },
  {
    key: "upload_type",
    label: "Uploaded via"
  },
  {
    key: "sales_order_id",
    label: "Order#"
  },
  {
    key: "tracking_number",
    label: "Tracking Number"
  },
  {
    key: "ship_from_id",
    label: "Ship From ID"
  },
  {
    key: "waybill_download",
    label: "Waybill"
  }
];

export default {
  name: "HKTOrders",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        status_selected: null
      },
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Fulfilled",
          text: "Fulfilled"
        },
        {
          value: "Failed",
          text: "Failed"
        }
      ],
      check_all_rows: false
    };
  },
  async created() {
    await this.getHKTOrders();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if(new_val == 'all'){ // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      }else{
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    exportCSV() {
      let export_url = process.env.VUE_APP_API_HOST;
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWayBill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_bulk_waybill.php",
        data: {
          items: this.items
        }
      });
      console.log(response.data);
      if(response.data.url){
        window.open(response.data.url, "_blank");
      }
      this.loader.hide();
    },

    async getHKTOrders() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_order_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria
        }
      });
      this.items = response.data.orders;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getHKTOrders();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getHKTOrders();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST+"/waybill?";
      // let url = "https://tracking.gols.com.hk/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_order_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        // alert("Upload success");
        window.location.reload();
      }
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/HKTOrders.vue